import withdrawalMessage from './withdrawalMessage'

export * from './withdrawalMessage'
export default withdrawalMessage
